export default __webpack_public_path__ + "static/media/IBimageKneeanglemidswing2.91bdd454.png";